<template>
  <div
    ref="preferencesModal"
    class="modal modal-v modal-v--normal fade"
    id="preferencesModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="preferencesModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body d-flex flex-column align-items-center justify-content-start">
          <h2 class="title title--large mb-1 mt-3 mt-md-0">{{ trans.get('profile:edit.preferences_modal.header') }}</h2>

          <ResponseComponent :response="response" class="text-center mb-3 desc desc--lightgrey"></ResponseComponent>

          <div class="desc desc--small text-center mb-3">
            <label for="preferences">{{ trans.get('profile:edit.preferences_modal.label') }}</label>
          </div>

          <form id="preferencesForm" @submit.prevent="sendForm">
            <PreferencesChooseComponent v-if="this.loaded" v-model="userPreferences" :preferences="preferences"></PreferencesChooseComponent>
          </form>

          <button form="preferencesForm" type="submit" class="button button__fill mx-auto mt-5 mb-3 js-modal-verify">
            {{ trans.get('profile:edit.preferences_modal.send') }}
          </button>

          <div class="d-flex justify-content-between align-content-center">
            <button type="button" class="button button__link mx-auto mb-3" data-dismiss="modal">
              {{ trans.get('profile:edit.preferences_modal.close_button') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HandleResponse from '../../scripts/vueHandleResponseErrors';
import ResponseComponent from '../ResponseComponent';
import { mapGetters } from 'vuex';
import PreferencesChooseComponent from './PreferencesChooseComponent.vue';

export default {
  name: 'PreferencesModal',
  components: { PreferencesChooseComponent, ResponseComponent },
  mixins: [HandleResponse],
  props: {},
  data() {
    return {
      open: false,
      loaded: false,
      send: false,
      startUserPreferences: 0,
      preferences: [],
      userPreferences: [],
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      userPrefFlag: 'getPrefFlag',
    }),
  },
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.preferencesModal).modal('show');
      } else {
        $(this.$refs.preferencesModal).modal('hide');
      }
    },
  },
  methods: {
    loadData: function () {
      let loadPref = axios // get all preferences
        .get(zRoute('ajax.preferences.index'))
        .then((response) => {
          this.preferences = response.data.data;
        });

      let loadUserPref = axios // get user preferences
        .get(zRoute('ajax.user.preferences.index'))
        .then((response) => {
          this.userPreferences = response.data.data.map((x) => x.id);
          this.startUserPreferences = this.userPreferences.length;
        });

      Promise.all([loadPref, loadUserPref]).then(() => {
        this.loaded = true;
      });
    },
    sendForm: function () {
      this.messages = null;
      axios
        .post(zRoute('ajax.user.preferences.update'), {
          preferences: this.userPreferences,
        })
        .then(() => {
          this.send = true;
          setTimeout(() => {
            this.open = false;
          }, 1000);
        })
        .catch((error) => {
          this.handleResponseErrors(error.response.data);
        });
    },
    sendDefault: function () {
      axios
        .post(zRoute('ajax.user.preferences.update'), {
          preferences: this.preferences.filter((v) => v.default).map((v) => v.id),
        });
    },
  },
  mounted() {
    this.$eventHub.$on('PreferencesModalOpen', () => {
      this.loadData();
      this.handleResponseClear();
      this.open = true;
    });

    $(this.$refs.preferencesModal).on('hidden.bs.modal', () => {
      if (!this.userPrefFlag && !this.send && this.startUserPreferences === 0) {
        this.sendDefault();
      }

      this.open = false;
    });
  },
};
</script>

<style scoped></style>
